module.exports = __webpack_public_path__ + "img/full_screen.c27af965.svg";